<template>
  <div class="bg-gray-200 rounded-lg overflow-hidden select-none p-0.5">
    <div class="relative items-center display-none hidden sm:flex">
      <!-- white sliding tab block -->
      <div
        class="absolute left-0 inset-y-0 flex bg-white transition-all ease-in-out duration-200 transform rounded-md shadow-md"
        :class="slidingTabBlockClass"
      ></div>

      <div
        v-for="tab in tabs"
        class="relative flex-1 flex text-sm font-medium capitalize items-center justify-center cursor-pointer m-px px-4 py-2"
        :class="widthTabBlockClass"
        @click="setSelectedTab(tab.type)"
        v-bind:key="tab.type"
      >
        {{ tab.name }}
      </div>
    </div>

    <div class="sm:hidden">
      <label for="tabs" class="sr-only">Select a tab</label>
      <select
        id="tabs"
        name="tabs"
        class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
        v-model="selectedTab"
      >
        <option v-for="tab in tabs" :value="tab.type" v-bind:key="tab.type">{{
          tab.name
        }}</option>
      </select>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: []
    },
    customStyle: {
      type: Object
    }
  },
  data() {
    return {
      selectedTab: "general"
    };
  },
  methods: {
    setSelectedTab(tabType) {
      this.selectedTab = tabType;
    }
  },
  computed: {
    slidingTabBlockClass() {
      let classObj = {};
      classObj["w-1/" + this.tabs.length] = true;
      this.tabs.forEach((tab, index) => {
        if (index == 0) {
          classObj["translate-x-0"] = this.selectedTab == tab.type;
        }
        if (index == 1) {
          classObj["translate-x-full"] = this.selectedTab == tab.type;
        }
        if (index >= 2) {
          classObj["translate-x-fullx" + index] = this.selectedTab == tab.type;
        }
      });
      return classObj;
    },
    widthTabBlockClass() {
      let classObj = {};
      classObj["w-1/" + this.tabs.length] = true;
      return classObj;
    }
  },
  watch: {
    selectedTab: function(tabType) {
      this.$emit("selectedTab", tabType);
    }
  }
};
</script>
